export { ViewSharePoint } from './ViewSharePoint';
